import React, { useMemo } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Row, Col } from 'antd'

import { ApplicationState } from 'src/store'
import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import { R8HeaderTableGeneric } from './r8-header-table-generic'
import R8HeaderTableAgencies from './r8-header-table-agencies'
import { WrapSectionHeader } from './styles'

function TableSort(a: R8HeaderTableGeneric, b: R8HeaderTableGeneric): number {
  const total = b.total - a.total
  return total !== 0 ? total : `${a.name}` > `${b.name}` ? 1 : -1
}

function SectionHeader() {
  const {
    reports: {
      reportsResources: {
        R8Data: { data },
        R8Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const buildResumes = useMemo(() => {
    let AgenciesData: R8HeaderTableGeneric[] = []
    let totalSumValue = 0

    for (let register of data) {
      const agencyIndex = AgenciesData.findIndex(
        item => item.name === register.supplier_name
      )

      if (agencyIndex > -1) {
        AgenciesData[agencyIndex].total += register.total_value
      } else {
        AgenciesData.push({
          name: register.supplier_name,
          total: register.total_value,
          percent: ''
        })
      }

      totalSumValue += register.total_value
    }
    AgenciesData = AgenciesData.reduce(
      (acc, { name, total }) => [
        ...acc,
        {
          name,
          percent: ((total * 100) / totalSumValue).toFixed(1),
          total
        }
      ],
      []
    ).sort(TableSort)

    return {
      AgenciesData
    }
  }, [data])

  const { AgenciesData } = buildResumes

  if (!header.length) {
    return null
  }

  const defaultInfo = ' - '

  const total_request_count = header[0].total_request_count || defaultInfo
  const total_request_tickets_count =
    header[0].total_request_tickets_count || defaultInfo
  const startedOn =
    moment.unix(header[0].started_on).utc().format('DD/MM/YYYY') || defaultInfo
  const endedOn =
    moment.unix(header[0].ended_on).utc().format('DD/MM/YYYY') || defaultInfo
  const total_tickets_sum = (
    <Text>
      {
        currencyMask({
          formatStr: true,
          precision: 2,
          value: header[0].total_sum
        }).maskedValue
      }
    </Text>
  )
  return (
    <WrapSectionHeader>
      <Row>
        <Col span={7}>
          <Row>
            <Col span={24}>
              <Text colon id="header" title="web.report.8.header.started-on">
                <span id="value">{startedOn}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text colon id="header" title="web.report.8.header.ended-on">
                <span id="value">{endedOn}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text
                colon
                id="header"
                title="web.report.8.header.total-request-count"
              >
                <span id="value">{total_request_count}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text
                colon
                id="header"
                title="web.report.8.header.total-request-tickets-count"
              >
                <span id="value">{total_request_tickets_count}</span>
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text colon id="header" title="web.report.8.header.total-sum">
                <span id="value">{total_tickets_sum}</span>
              </Text>
            </Col>
          </Row>
        </Col>
        <Row>
          <Col span={24}>
            {header[0].emitted && <Text title="web.report.6.emitted" />}
          </Col>
        </Row>
        <Col offset={8} span={8}>
          <R8HeaderTableAgencies dataSource={AgenciesData} />
        </Col>
      </Row>
    </WrapSectionHeader>
  )
}

export default SectionHeader
